export const AUTOCLOSE_NOTIFICATION_TIMEOUT = 3000;
